<template>
  <div class="pa-4 pa-md-8 grey lighten-4 min-vh-100">
    <vue-element-loading 
      :active="appLoading" 
      :is-full-screen="true" 
      background-color="rgba(255, 255, 255, 0.9)" 
      color="#1A237E"
      spinner="mini-spinner" 
    />

    <ServerError v-if="ServerError" />

    <v-row class="mb-6 align-center">
      <v-col cols="12" md="8">
        <h2 class="page-title mb-1">Conservation Overview</h2>
        <p class="subtitle-1 grey--text text--darken-1 font-weight-medium">
          Welcome back, Admin. Monitoring whale shark activity in real-time.
        </p>
      </v-col>
      <v-col cols="12" md="4" class="text-md-right">
        <v-btn color="#1A237E" dark depressed class="rounded-lg px-6" to="/admin/reports">
          <v-icon left>mdi-file-chart</v-icon> View All Reports
        </v-btn>
      </v-col>
    </v-row>

    <v-row class="mb-8">
      <v-col cols="12" sm="6" lg="3">
        <v-card flat class="rounded-xl border-light pa-4 hover-lift fill-height" @click="navigateToUserList">
          <div class="d-flex align-center mb-4">
            <v-avatar color="blue lighten-5" size="48">
              <v-icon color="blue darken-4">mdi-account-group</v-icon>
            </v-avatar>
            <v-spacer></v-spacer>
            <v-chip x-small color="success" class="font-weight-black">ACTIVE</v-chip>
          </div>
          <div class="text-overline grey--text font-weight-bold">Registered Users</div>
          <div class="display-1 font-weight-black navy--text">{{ usercount }}</div>
          <div class="caption grey--text mt-2">Verified conservationists</div>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" lg="3">
        <v-card flat class="rounded-xl border-light pa-4 hover-lift fill-height" @click="navigateToRecordList">
          <div class="d-flex align-center mb-4">
            <v-avatar color="orange lighten-5" size="48">
              <v-icon color="orange darken-4">mdi-database-search</v-icon>
            </v-avatar>
            <v-spacer></v-spacer>
            <v-chip x-small color="orange" dark class="font-weight-black">LATEST</v-chip>
          </div>
          <div class="text-overline grey--text font-weight-bold">Total Sightings</div>
          <div class="display-1 font-weight-black navy--text">{{ recordcount }}</div>
          <div class="caption grey--text mt-2">Historical & rescue records</div>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" lg="3">
        <v-card flat class="rounded-xl border-light pa-4 fill-height bg-navy" dark>
          <div class="d-flex align-center mb-4">
            <v-avatar color="rgba(255,255,255,0.1)" size="48">
              <v-icon>mdi-shield-check</v-icon>
            </v-avatar>
          </div>
          <div class="text-overline grey--text text--lighten-1 font-weight-bold">System Status</div>
          <div class="text-h5 font-weight-black">Operational</div>
          <div class="caption grey--text text--lighten-2 mt-2">API & Database Synced</div>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" lg="3">
        <v-card flat class="rounded-xl border-light pa-4 fill-height d-flex flex-column justify-center align-center text-center grey lighten-5 border-dashed" to="/admin/privacy">
          <v-icon color="grey darken-1" large>mdi-cog-outline</v-icon>
          <div class="font-weight-bold grey--text text--darken-2 mt-2">Manage Policies</div>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card flat class="rounded-xl border-light elevation-2 overflow-hidden">
          <div class="pa-5 d-flex align-center white">
            <div>
              <h3 class="navy--text font-weight-black mb-0">Live Rescue Distribution</h3>
              <span class="caption grey--text font-weight-bold text-uppercase">Mapping active sightings across Gujarat</span>
            </div>
            <v-spacer></v-spacer>
            <v-btn icon @click="getMapData"><v-icon>mdi-refresh</v-icon></v-btn>
          </div>
          <div id="googlemap"></div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
/* global google */
import axios from "axios";

export default {
  data() {
    return {
      ServerError: false,
      appLoading: false,
      recordcount: 0,
      usercount: 0,
      gmap: null,
      records: [],
      // Custom Whale Icon for Map
      whaleMarker: {
        url: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsPSIjMUEyMzdFIiBkPSJNMTggMTQuNWMtMS43IDAtMy4yLS43LTQuMy0xLjhjLTEuMSAxLjEtMi42IDEuOC00LjMgMS44cy0zLjItLjctNC4zLTEuOGMtMS4xIDEuMS0yLjYgMS44LTQuMyAxLjhWMTdjMS43IDAgMy4yLS43IDQuMy0xLjhjMS4xIDEuMSAyLjYgMS44IDQuMyAxLjhzMy4yLS43IDQuMy0xLjhjMS4xIDEuMSAyLjYgMS44IDQuMyAxLjhzMy4yLS43IDQuMy0xLjhjMS4xIDEuMSAyLjYgMS44IDQuMyAxLjh2LTIuNXoiLz48cGF0aCBmaWxsPSIjMUEyMzdFIiBkPSJNMTIgMmMtNS41IDAtMTAgNC41LTEwIDEwczQuNSAxMCAxMCAxMHMxMC00LjUgMTAtMTBTMi41IDIgMTIgMnptMCAxOGMtNC40IDAtOC0zLjYtOC04czMuNi04IDgtOHM4IDMuNiA4IDhzLTMuNiA4LTggOHoiLz48L3N2Zz4=',
        scaledSize: new google.maps.Size(40, 40),
        anchor: new google.maps.Point(20, 20),
      }
    };
  },

  mounted() {
    this.initMap();
    this.fetchDashboardStats();
    this.getMapData();
  },

  methods: {
    navigateToUserList() { this.$router.push('/admin/userlist'); },
    navigateToRecordList() { this.$router.push('/admin/reports'); },

    async fetchDashboardStats() {
      this.appLoading = true;
      try {
        const res = await axios({
          url: "/admin/home",
          method: "get",
          headers: { token: localStorage.getItem("token") },
        });
        if (res.data.status) {
          this.recordcount = res.data.recordcount;
          this.usercount = res.data.usercount;
        }
      } catch (err) {
        this.ServerError = true;
      } finally {
        this.appLoading = false;
      }
    },

    initMap() {
      const mapOptions = {
        center: { lat: 20.9, lng: 70.4 }, // Veraval / Gir Somnath Coast focus
        zoom: 8,
        disableDefaultUI: true,
        zoomControl: true,
        styles: [
          { "featureType": "water", "stylers": [{ "color": "#E3F2FD" }] },
          { "featureType": "landscape", "stylers": [{ "color": "#f1f3f5" }] },
          { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [{ "color": "#cfd8dc" }, { "weight": 1 }] }
        ]
      };
      this.gmap = new google.maps.Map(document.getElementById("googlemap"), mapOptions);
    },

    async getMapData() {
      try {
        const res = await axios({
          url: "/record/coordinates",
          method: "get",
          headers: { token: localStorage.getItem("token") },
        });
        if (res.data.status) {
          this.records = res.data.data;
          this.records.forEach(record => {
            if (record.location && record.location.length === 2) {
              const marker = new google.maps.Marker({
                position: { lat: record.location[1], lng: record.location[0] },
                map: this.gmap,
                icon: this.whaleMarker,
                animation: google.maps.Animation.DROP,
              });

              const infowindow = new google.maps.InfoWindow({
                content: `
                  <div class="pa-2" style="font-family: 'Inter', sans-serif">
                    <div class="text-subtitle-2 font-weight-black navy--text mb-1">${record.boatname || 'Unknown Vessel'}</div>
                    <div class="caption grey--text mb-2">Registration: ${record.boatno || 'N/A'}</div>
                    <a href="/admin/uploaddetail?id=${record._id}" class="v-btn v-btn--flat v-btn--text theme--light v-size--x-small primary--text font-weight-bold" style="text-decoration: none">
                      VIEW SIGHTING →
                    </a>
                  </div>
                `,
                maxWidth: 250,
              });

              marker.addListener("click", () => {
                infowindow.open(this.gmap, marker);
              });
            }
          });
        }
      } catch (err) {
        console.error("Map Data Error:", err);
      }
    },
  },
};
</script>

<style scoped>
#googlemap {
  height: 600px;
  width: 100%;
}

.page-title {
  font-family: 'Syne', sans-serif;
  font-weight: 800;
  text-transform: uppercase;
  color: #1A237E;
  letter-spacing: 1.5px;
}

.navy--text { color: #1A237E; }
.bg-navy { background-color: #1A237E !important; }

.hover-lift {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  cursor: pointer;
}
.hover-lift:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(0,0,0,0.1) !important;
}

.border-light { border: 1px solid rgba(0,0,0,0.06) !important; }
.border-dashed { border: 2px dashed #CFD8DC !important; }

.letter-spaced { letter-spacing: 1px !important; }

/* Custom Infowindow styling hack */
::v-deep .gm-style-iw-d {
  overflow: hidden !important;
}
</style>